import { render } from "./Templates.vue?vue&type=template&id=00c492ea"
import script from "./Templates.vue?vue&type=script&lang=ts"
export * from "./Templates.vue?vue&type=script&lang=ts"
script.render = render

export default script